/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { DateTime, DateTimeInterface } from "../DateTime";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getDay",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "month",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "year",
        type: "uint16",
      },
    ],
    name: "getDaysInMonth",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getHour",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getMinute",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getMonth",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getSecond",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getWeekday",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "getYear",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "year",
        type: "uint16",
      },
    ],
    name: "isLeapYear",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "year",
        type: "uint256",
      },
    ],
    name: "leapYearsBefore",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "year",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "month",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "day",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "hour",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "minute",
        type: "uint8",
      },
    ],
    name: "toTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "year",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "month",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "day",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "hour",
        type: "uint8",
      },
    ],
    name: "toTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "year",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "month",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "day",
        type: "uint8",
      },
    ],
    name: "toTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "year",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "month",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "day",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "hour",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "minute",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "second",
        type: "uint8",
      },
    ],
    name: "toTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DateTime__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DateTime> {
    return super.deploy(overrides || {}) as Promise<DateTime>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DateTime {
    return super.attach(address) as DateTime;
  }
  connect(signer: Signer): DateTime__factory {
    return super.connect(signer) as DateTime__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DateTimeInterface {
    return new utils.Interface(_abi) as DateTimeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DateTime {
    return new Contract(address, _abi, signerOrProvider) as DateTime;
  }
}
